/* @flow */
import React from 'react';
// $FlowIgnore
import { MdTimeline } from 'react-icons/md';

export default function TransactionIcon({
  style, type
}: Object): React.Element {
  return (
    <MdTimeline style={{
      color: {
        'upload': 'skyblue',
        'open': 'skyblue',
        'delete': 'orangered',
        'review': 'orange',
        'submit': 'orange',
        'release': 'forestgreen'
      }[type], ...style}}
    />
  );
}
